import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const { VITE_KA_URL, VITE_KA_DOMAIN } = import.meta.env;

function hasTracking() {
  return VITE_KA_URL && VITE_KA_DOMAIN;
}

function setupTracking() {
  if (!hasTracking()) return;

  const c = {
    url: VITE_KA_URL,
    domain: VITE_KA_DOMAIN,
  };

  window.ka = c;
  const s = document.createElement('script');

  s.defer = true;
  s.src = [c.url, '/ka.js'].join('');
  document.body.appendChild(s);
}

setupTracking();

export function track(path: string) {
  if (hasTracking() && window.ka.track) {
    window.ka.track(path);
  }
}

export function useTracking() {
  const location = useLocation();

  useEffect(() => {
    track(location.pathname);
  }, [location.pathname]);
}
